<div class="product-details-skeleton">
    <!-- Header Skeleton -->
    <div class="row align-items-center mb-4 g-3">
        <div class="col-12 col-md-auto text-center text-md-start">
            <app-skeleton-rect width="250px" height="32px" class="mb-2 d-inline-block"></app-skeleton-rect>
            <app-skeleton-rect width="180px" height="18px" class="mb-2 d-block mx-auto mx-md-0"></app-skeleton-rect>
            <app-skeleton-rect width="150px" height="14px" class="d-block mx-auto mx-md-0"></app-skeleton-rect>
        </div>
        <div
            class="col-12 col-md-auto ms-md-auto d-flex justify-content-center justify-content-md-end align-items-center gap-2">
            <app-skeleton-rect width="140px" height="38px" [borderRadius]="'8px'"></app-skeleton-rect>
            <app-skeleton-rect width="100px" height="38px" [borderRadius]="'8px'"></app-skeleton-rect>
        </div>
    </div>

    <div class="row match-height">
        <!-- Main Info (Left Column) -->
        <div class="col col-lg-8">
            <!-- Title & Description Card -->
            <div class="card mb-4">
                <div class="card-body">
                    <div class="mb-4">
                        <app-skeleton-rect width="150px" height="16px" class="mb-2 d-block"></app-skeleton-rect>
                        <app-skeleton-rect width="100%" height="40px" class="d-block"></app-skeleton-rect>
                    </div>
                    <div class="mb-2">
                        <app-skeleton-rect width="180px" height="16px" class="mb-2 d-block"></app-skeleton-rect>
                        <app-skeleton-rect width="100%" height="150px" class="d-block"></app-skeleton-rect>
                    </div>
                </div>
            </div>

            <!-- Multimedia Card -->
            <div class="card mb-4">
                <div class="card-header d-flex justify-content-between">
                    <app-skeleton-rect width="180px" height="22px"></app-skeleton-rect>
                    <app-skeleton-rect width="100px" height="32px" [borderRadius]="'6px'"></app-skeleton-rect>
                </div>
                <div class="card-body">
                    <app-skeleton-rect width="220px" height="14px" class="mb-3 d-block"></app-skeleton-rect>
                    <app-skeleton-rect width="100%" height="200px" [borderRadius]="'8px'"
                        class="d-block"></app-skeleton-rect>
                </div>
            </div>
        </div>

        <!-- Sidebar Info (Right Column) -->
        <div class="col-lg-4">
            <!-- Status Card -->
            <div class="card mb-4">
                <div class="card-body d-flex justify-content-between align-items-center">
                    <app-skeleton-rect width="120px" height="20px"></app-skeleton-rect>
                    <div class="d-flex align-items-center gap-2">
                        <app-skeleton-rect width="80px" height="24px" [borderRadius]="'12px'"></app-skeleton-rect>
                        <app-skeleton-rect width="45px" height="24px" [borderRadius]="'12px'"></app-skeleton-rect>
                    </div>
                </div>
            </div>

            <!-- Inventory & Categories Card -->
            <div class="card mb-4">
                <div class="card-body">
                    <div class="mb-4">
                        <app-skeleton-rect width="120px" height="16px" class="mb-2 d-block"></app-skeleton-rect>
                        <app-skeleton-rect width="100%" height="38px" class="d-block"></app-skeleton-rect>
                    </div>
                    <div>
                        <app-skeleton-rect width="100px" height="16px" class="mb-2 d-block"></app-skeleton-rect>
                        <app-skeleton-rect width="100%" height="38px" class="d-block"></app-skeleton-rect>
                    </div>
                </div>
            </div>

            <!-- Pricing Card -->
            <div class="card mb-4">
                <div class="card-header">
                    <app-skeleton-rect width="100px" height="20px"></app-skeleton-rect>
                </div>
                <div class="card-body">
                    <div class="mb-4">
                        <app-skeleton-rect width="120px" height="16px" class="mb-2 d-block"></app-skeleton-rect>
                        <app-skeleton-rect width="100%" height="38px" class="d-block"></app-skeleton-rect>
                    </div>
                    <div class="mb-4">
                        <app-skeleton-rect width="130px" height="16px" class="mb-2 d-block"></app-skeleton-rect>
                        <app-skeleton-rect width="100%" height="38px" class="d-block"></app-skeleton-rect>
                    </div>
                    <div class="mb-2">
                        <app-skeleton-rect width="140px" height="16px" class="mb-2 d-block"></app-skeleton-rect>
                        <app-skeleton-rect width="100%" height="38px" class="d-block"></app-skeleton-rect>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>